import { formatDate, parseDate } from "@luce/core/utils";

import { PackageStatusEnum } from "../__generated__/graphql";
import type { PackageItem } from "./gqlhooks/use-packages-by-filters";

export function getPackageStatusTag(status: PackageStatusEnum) {
  return status === PackageStatusEnum.Active
    ? ({ label: "Active", variant: "primary" } as const)
    : ({ label: "Inactive", variant: "neutral" } as const);
}

export function formatPackageDate(date?: string | null) {
  return date ? formatDate(parseDate(date), "dd MMM yyyy") : null;
}

export function formatPackagePeriod({ startDate, endDate }: PackageItem) {
  return `${formatPackageDate(startDate) ?? "N/A"} - ${formatPackageDate(endDate) ?? "Not Set"}`;
}

export function formatPackageAddress({
  fullAddress,
  unitNumber,
  postalCode,
}: Pick<PackageItem, "fullAddress" | "unitNumber" | "postalCode">) {
  return [fullAddress, unitNumber, postalCode ? `Singapore ${postalCode}` : "Singapore"]
    .filter(Boolean)
    .join(", ");
}
